import ApiService from "@/core/services/api.service";

const state = {
  items: [],
};

const getters = {
  menuItems(state) {
    return state.items;
  },
};

const actions = {
  fetchMenu({ commit, rootGetters }) {
    const userInfo = rootGetters["userInfo"];

    return new Promise((resolve, reject) => {
      ApiService.post("api/v2/menus", {
        roleId: userInfo.roleId,
      })
        .then(({ data }) => {
          commit("setMenu", data);
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

const mutations = {
  setMenu(state, payload) {
    state.items = payload;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
